import React from 'react'
import { Navigate } from 'react-router'
import { sportsOfferingQueryKeys } from '@mobi/sports-offering/helpers/queries/keys'
import { AppRoutes } from '@core/AppRoutes'
import { useForceAppHeaderFixed } from '@core/Areas/AppHeader/hooks/useForceAppHeaderFixed'
import { useKambiMaintenanceFeature } from '@core/Areas/KambiClient/Components/KambiRouteEffects/hooks'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { MaintenanceScreen } from './Components/MaintenanceScreen'
import { useNewSportsOfferingFeature } from './hooks/useNewSportsOfferingFeature'
import { useToggleKambiBetSlipVisibility } from './hooks/useToggleKambiBetSlipVisibility'

const SportsOfferingLazyRoute = React.lazy(() => import('./Components/MainSportsOffering'))

export const SportOfferingRoot: React.FC = () => {
  const isKambiSportsOfferingEnabled = useNewSportsOfferingFeature()
  useToggleKambiBetSlipVisibility(isKambiSportsOfferingEnabled)
  const maintenanceEndDate = useKambiMaintenanceFeature()
  useForceAppHeaderFixed()

  React.useEffect(() => {
    if (maintenanceEndDate) {
      queryClient.invalidateQueries({
        queryKey: sportsOfferingQueryKeys.SportsOfferingBase,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.kambiPlayerBase,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.kambiShapeGamesBase,
        refetchType: 'all',
      })
    }
  }, [maintenanceEndDate])

  if (maintenanceEndDate) {
    return <MaintenanceScreen endDate={maintenanceEndDate} />
  }

  if (!isKambiSportsOfferingEnabled) {
    return <Navigate to={AppRoutes.SportsRoot + '/home'} replace />
  }

  return (
    <React.Suspense fallback={null}>
      <SportsOfferingLazyRoute />
    </React.Suspense>
  )
}
